var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgMilestoneBlack = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.07454 0.925463L0.824958 9.17504C0.369346 9.63065 0.369346 10.3693 0.824958 10.825L9.07454 19.0745C9.53015 19.5301 10.2688 19.5301 10.7245 19.0745L18.974 10.825C19.4296 10.3693 19.4296 9.63065 18.974 9.17504L10.7245 0.925463C10.2688 0.469851 9.53015 0.469851 9.07454 0.925463ZM9.89949 18.2496L1.64992 10L9.89949 1.75042L18.1491 10L9.89949 18.2496Z",
    fill: "black"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgMilestoneBlack);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/milestone-black.1e8d67c797d2d0d796fd36ea3cf3218a.svg";